import {ValueObject} from '@s-ui/domain'

import {VehicleDataValueObject} from './VehicleDataValueObject.js'

export class VehicleDataListValueObject extends ValueObject {
  #value

  constructor({value}) {
    super()
    this.#value = value
  }

  static create({value}) {
    return new VehicleDataListValueObject({
      value: value.map(data => VehicleDataValueObject.create(data))
    })
  }

  static createFromApi({value}) {
    const valueWithDefault = value ?? []
    return new VehicleDataListValueObject({
      value: valueWithDefault.map(value => VehicleDataValueObject.create({text: value?.text, type: value?.type}))
    })
  }

  get value() {
    return this.#value.map(data => data.value)
  }

  toJSON() {
    return {value: this.#value.map(data => data.toJSON())}
  }
}
